import { render, staticRenderFns } from "./ClientsPolicies.vue?vue&type=template&id=37841438"
import script from "./ClientsPolicies.vue?vue&type=script&lang=js"
export * from "./ClientsPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports